<template>
  <span v-if="disable">{{ text }}</span>
  <a v-else-if="absUrl" :href="absUrl" class="link" :target="newTab ? '_blank' : ''" rel="noopener noreferrer">
    {{ text }}
  </a>
  <router-link v-else class="link" :to="route" :target="newTab ? '_blank' : ''">
    {{ text }}
  </router-link>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'AgGridTextLink',

  computed: {
    // props
    disable() {
      return this.params.disable || false
    },

    text() {
      return this.params.text
    },

    newTab() {
      return this.params.newTab || false
    },

    absUrl() {
      return this.params.absUrl || false
    },

    route() {
      return this.params.route
    }
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.link {
  text-decoration none
  color $accent-colour

  &:hover {
    text-decoration underline
  }
}
</style>
